/** Spaja CSS klase, preskače prazne vrijednosti. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}

export type Tone = 'ok' | 'caution' | 'danger' | 'info' | 'neutral';

/** Tekst + pozadina za statusni ton (kao funkcija `S()` u dizajnu). */
export const toneClass: Record<Tone, string> = {
  ok: 'text-ok bg-ok-bg',
  caution: 'text-caution bg-caution-bg',
  danger: 'text-danger bg-danger-bg',
  info: 'text-info bg-info-bg',
  neutral: 'text-muted bg-bg2',
};

export const toneText: Record<Tone, string> = {
  ok: 'text-ok',
  caution: 'text-caution',
  danger: 'text-danger',
  info: 'text-info',
  neutral: 'text-muted',
};

export const phaseColor = (index: number) => `var(--ph${index})`;
